export enum ReportEnum {
  SaleReport = 1,
  ReferenceCommissionReport = 2,
  PaymentReport = 3,
  ProductPurchaseReport = 4,
}
